import { render, staticRenderFns } from "./LiquidityTable.vue?vue&type=template&id=2284c030&scoped=true&"
import script from "./LiquidityTable.vue?vue&type=script&lang=ts&"
export * from "./LiquidityTable.vue?vue&type=script&lang=ts&"
import style0 from "./LiquidityTable.vue?vue&type=style&index=0&id=2284c030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2284c030",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDataTable,VIcon,VRow})
